import { render, staticRenderFns } from "./LLAddLabel.vue?vue&type=template&id=f53ffb4a&scoped=true"
import script from "./LLAddLabel.vue?vue&type=script&lang=js"
export * from "./LLAddLabel.vue?vue&type=script&lang=js"
import style0 from "./LLAddLabel.vue?vue&type=style&index=0&id=f53ffb4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53ffb4a",
  null
  
)

export default component.exports